import { useState } from "react";
import { useLocation } from 'react-router-dom';
import { useQuery } from "@tanstack/react-query";

import { IconButton, Button } from "@mui/material";
import TuneIcon from '@mui/icons-material/Tune';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel} from '@fortawesome/free-solid-svg-icons';
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";

import useAxios from "../components/useAxios";


import { Dropdown, Menu, Space, DatePicker, Radio, Segmented } from 'antd';



// import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

import authAxios from "../components/authAxios";

import moment from 'moment';

import DashboardHeader from "../components/DashboardHeader";
import './Report.css'
import Loading from "../components/Loading";

import OwnerStatementAccrual from "./OwnerStatementAccrual";
import OwnerStatementCash from "./OwnerStatementCash";


const OwnerStatement = () => {
    const location = useLocation();

    const { data, fetchData}  = useAxios();   

    const property = location.state.property;
    const [reportMonth, setReportMonth] = useState(moment().format('MM'))
    const [reportYear, setReportYear] = useState(moment().format('YYYY'))
    const [filterDate, setFilterDate] = useState(null)
    const [isMonthPicker, setIsMonthPicker] = useState(true); // State to track picker type
    const [showSchedules, setShowSchedules] = useState(false);

    const [pdfLoading, setPdfLoading] = useState(false);


    const [reportType, setReportType] = useState('Accrual');
    const [feeBasis, setFeeBasis] = useState();

    const { data: ownerStatement, isLoading } = useQuery({
        queryKey: ['owner-statement', reportMonth, reportYear, filterDate, reportType],
        queryFn: async () => {
            const response = await authAxios.get(`/rentals/owner-statement/?property=${property.id}&month=${reportMonth}&year=${reportYear}&filter_date=${filterDate}`);
            const data = response.data
            setShowSchedules(
                data.schedules.payments.length > 0 || 
                data.schedules.collections.length > 0 || 
                data.schedules.expenses.length > 0 || 
                data.schedules.adjustments.length > 0
            );
            setFeeBasis(data.management_fee_basis)
            return data
            // return response.data
        },
    });

    

    const StatementComponent = feeBasis?.toUpperCase() === 'ACCRUAL' ? OwnerStatementAccrual : OwnerStatementCash;



    // For PDF download
    const downloadPDF1 = async () => {
        try {
            const response = await fetch(
                `/api/rentals/owner-statement/pdf/?month=${reportMonth}&year=${reportYear}&property=${property.id}`,
                {
                    method: 'GET',
                    headers: {
                        // Add authorization if needed, e.g.:
                        // 'Authorization': `Bearer ${yourToken}`
                    }
                }
            );
            if (!response.ok) throw new Error('Failed to download PDF');
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `owner_statement_${property.name}_${reportMonth}_${reportYear}.pdf`;
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            alert('PDF download failed');
            console.error(err);
        }
    };

    const downloadPDF = async () => {
        setPdfLoading(true);

        try {
            const response = await authAxios.get(
                `/rentals/owner-statement/pdf/?month=${reportMonth}&year=${reportYear}&property=${property.id}`,
                {
                    responseType: 'blob'
                }
            );
            const filename = `owner_statement_${property.name}_${reportMonth}_${reportYear}.pdf`;
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            alert('PDF download failed');
            console.error(err);
        } finally {
            setPdfLoading(false);
        }
    };


    // console.log("BAL",totalBalanceBf)
    const downloadXLS = () => {

        const worksheetData = ownerStatement.report_data.map(data => ({
            'House No': data.house_no,
            'Tenant': data.customer,
            'Contact': data.contact,
            'Balance B/F': parseFloat(data.balance_brought_forward),
            'Amount Payable': parseFloat(data.amount_payable),
            'Amount Paid': parseFloat(data.amount_paid),
            'Balance': parseFloat(data.balance),
        })); // Add totals row at the end
    // })).concat(totalsRow); // Add totals row at the end

       
        const totalsRow = {
            'House No': 'TOTALS', // Adjust label if needed
            'Tenant': '', 
            'Contact': '',
            // 'Balance B/F': totalBalanceBf,
            // 'Amount Payable': totalAmountPayable,
            // 'Amount Paid': totalAmountPaid,
            // 'Balance': totalBalance,
          };

        // Add totals row to the worksheet data
        worksheetData.push(totalsRow);
        

        // Convert data to worksheet
        const ws = XLSX.utils.json_to_sheet(worksheetData);
       

        // console.log("WS", ws)
        // console.log("TOTALS", wsTotals)


        // Append totals to the worksheet
        // XLSX.utils.sheet_add_json(ws, [wsTotals[0]], { skipHeader: true, origin: -1 });

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Collection Report');

        XLSX.writeFile(wb, `Collection_Report_${property.name}_${reportMonth}_${reportYear}.xlsx`);
    };

    const disabledDate = (current) => {
        const startOfMonth = moment().startOf('month');
        return current && (current < startOfMonth || current > moment());
    };

    const onChange = (date, dateString) => {
        setReportMonth(date.month()+1)
        setReportYear(date.year())
        if (!isMonthPicker) {
            setFilterDate(dateString);
        }
        else {
            setFilterDate(null);
        }
      };

      

    // const menu = (
    //     <Menu>
    //         <form className="filter-form">
    //             <Space direction="vertical">
    //             <Radio.Group style={{ width:'100%', padding:'10px'}} onChange={(e) => setIsMonthPicker(e.target.value === 'month')} defaultValue="month">
    //                 <Radio.Button value="month" style={{ width: '50%' }}>Month</Radio.Button>
    //                 <Radio.Button value="date" style={{ width: '50%' }}>Date</Radio.Button>
    //             </Radio.Group>
    //                 {isMonthPicker ? (
    //                     <DatePicker style={{margin:'10px'}}  onChange={onChange} picker="month" placement="bottomRight" />
    //                 ) : (
    //                     <DatePicker 
    //                         style={{margin:'10px'}}  
    //                         onChange={onChange} 
    //                         picker="date" 
    //                         placement="bottomRight" 
    //                         disabledDate={disabledDate} 
    //                     />
    //                 )}
    //             </Space>
    //         </form>
    //     </Menu>

    //   );

    const reportPreTitle=property.name+" - PERIOD "+reportMonth+"/"+reportYear


    // a helper function to check if a column has data
    const hasColumnData = (columnName) => {
        return ownerStatement.report_data.some(row => row[columnName] !== 0 && row[columnName] !== null && row[columnName] !== undefined);
      };
    
    const formatNumber = (number) => {
        if (number === undefined || number === null) return '0.00';
        return number.toLocaleString('en-UK', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }



    if (isLoading) return <Loading loading={true} />;

    if(pdfLoading) return <Loading loading={true} />;

    // {pdfLoading && (
    //     <div className="pdf-loading-overlay">
    //       <CircularProgress />
    //       <span>Generating PDF...</span>
    //     </div>
    //   )}


   
    return (
        <StatementComponent 
            onChange={onChange}
            ownerStatement={ownerStatement}
            reportPreTitle={reportPreTitle}
            hasColumnData={hasColumnData}
            formatNumber={formatNumber}
            downloadPDF={downloadPDF}
            downloadXLS={downloadXLS}
            showSchedules={showSchedules}
            reportType={reportType}
            setReportType={setReportType}
            disabledDate={disabledDate}
            isMonthPicker={isMonthPicker}
            setIsMonthPicker={setIsMonthPicker}
        />
    );
};

export default OwnerStatement;
